export const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const capitalizeFirstNew= (text) =>{
    if (!text) return "";
    return text
      .split("-") // Split the string into an array by the hyphen
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(" "); // Join the words back together with a space
  }